export default __webpack_public_path__ + "static/media/Commander's Helm of the Ascending Kingdom.ab6baefc.jpg";